/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleRelationalTagModel } from '../../models/article-relational-tag-model';

export interface ArticlePublisherIdIdRelationalTagLanguageIdGet$Plain$Params {
  publisherId: string;
  id: string;
  languageId: string;
}

export function articlePublisherIdIdRelationalTagLanguageIdGet$Plain(http: HttpClient, rootUrl: string, params: ArticlePublisherIdIdRelationalTagLanguageIdGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<ArticleRelationalTagModel>>> {
  const rb = new RequestBuilder(rootUrl, articlePublisherIdIdRelationalTagLanguageIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('publisherId', params.publisherId, {});
    rb.path('id', params.id, {});
    rb.path('languageId', params.languageId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<Array<ArticleRelationalTagModel>>;
    })
  );
}

articlePublisherIdIdRelationalTagLanguageIdGet$Plain.PATH = '/Article/{publisherId}/{id}/RelationalTag/{languageId}';
